/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getProductsFromIndexedDB, resetAndSaveProducts, saveProductsToIndexedDB } from "src/shared/utils/indexDB/indexedDB";
import { getProduct } from "src/shared/services/services";
import { errorHandling } from "src/shared/utils/errorHandling";
import { useUser } from "../components/UserContext";
import { Product } from "src/shared/services/interfacev2";
import { closeLoading, notifyLoading, notifySuccess, notifyWarning } from "src/assets/toastService";

const useProductsIndexDB = (deleted?: boolean, page?: number, limit?: number, sortField?: string, order?: string) => {
  const [product, setProduct] = useState<Product[]>([]);
  const [loadingPro, setLoading] = useState<boolean>(true);
  const { user } = useUser();

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const products = await getProductsFromIndexedDB();

      if (products?.length && user && user.orgId) {
        const filterByOrg = products.filter((p: any) => p.orgId === user?.orgId);
        const formattedProducts = filterByOrg.map((p: any) => ({
          ...p,
          _id: typeof p._id === "string" ? { $oid: p._id } : p._id,
        }));
        productData(formattedProducts);
      } else {
        productSync();
      }
    } catch (error) {
      console.error("IndexedDB Load Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const productData = (avabileProduct: Product[] | []) => {
    if (avabileProduct.length) {
      setProduct(avabileProduct);
    } else {
      productSync();
    }
  };

  const productSync = () => {
    notifyLoading("Loading Products...");
    getProduct(deleted, page, limit, undefined, undefined, sortField, order)
      .then((res) => {
        const productAvabile = res.data.results;
        resetAndSaveProducts(productAvabile);
        setProduct(productAvabile);
        closeLoading();
        if (productAvabile.length) {
          notifySuccess("Products Updated Successfully");
        } else {
          notifyWarning("No Products Found");
        }
      })
      .catch((err) => {
        closeLoading();
        errorHandling(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    product,
    loadingPro,
    productSync,
  };
};

export default useProductsIndexDB;
